import { render, staticRenderFns } from "./refrigVelHumidityDetail.vue?vue&type=template&id=637a1289&scoped=true"
import script from "./refrigVelHumidityDetail.vue?vue&type=script&lang=js"
export * from "./refrigVelHumidityDetail.vue?vue&type=script&lang=js"
import style0 from "./refrigVelHumidityDetail.vue?vue&type=style&index=0&id=637a1289&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637a1289",
  null
  
)

export default component.exports